import type { PageLoadEvent } from './$types';
import { loadDropSections } from '#lib/features/drop-page/utils/loadDropSections/loadDropSections.js';

// Runs before the page renders, on the server and before hydration or a
// client-side navigation, so the drop page has the components of its
// sections, and only those, on its first render.
export const load = async ({ data }: PageLoadEvent) => ({
	...data,
	dropSections: await loadDropSections(data.componentItems),
});
